import { render, staticRenderFns } from "./SupportPartners.vue?vue&type=template&id=4abf7312&"
import script from "./SupportPartners.vue?vue&type=script&lang=js&"
export * from "./SupportPartners.vue?vue&type=script&lang=js&"
import style0 from "./SupportPartners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports